import flurrySystems from '../assets/flurry-systems.png';
import projectThree from '../assets/project-3.png';

const projects = {
  1: {
    title: 'Flurry Systems',
    image: flurrySystems,
    description:
      'An adaptive productivity ecosystem for people who value flow, not hustle. Flurry connects intelligent tools, templates, and automations into one platform that balances focus, wellness, and efficiency.',

    github: 'https://github.com/krystleM26/flurrysystems',
    demo: 'https://flurrysystems.com',
  },
  2: {
    title: 'Mario Game',
    image: projectThree,
    description:
      'Mario replica',

    github: 'https://github.com/krystleM26/mario-game',
    demo: 'In Progress',
  },
};

export default projects;
